import type ModalConversationInterceptorService from '../../../modals/modal-conversation-interceptor.service';

/*@ngInject*/
export function registerDocumentDetailsInterceptors(modalConversationInterceptor: ModalConversationInterceptorService): void {
    modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('ExemplarsHaveNotDeletableStatusException');
    modalConversationInterceptor.registerFieldEnablingConfirmationDialogFromExceptionHandler('LoanRequestDocumentWasLoanedInPastException');
}